export default {
    subheaderHint: 'subheader-hint-hidden-',
    allHints: 'report-hint-hidden-all',
    reportHint: 'report-hint-hidden-',
};
